
export default class LiquidationModel {
  constructor(obj) {
    obj = obj || {};

    this.id = obj.id;
    this.description = obj.description;
  }
}